module.exports = __webpack_public_path__ + "static/media/check.c46fe931.svg";